import React, { useState, useEffect } from "react";
import { TonConnectButton, useTonConnectUI } from "@tonconnect/ui-react";

const WalletActions = ({ closeModal }) => {
    const [tonConnectUI] = useTonConnectUI();
    const [isConnected, setIsConnected] = useState(false);

    // Проверяем локальный статус подключения при монтировании
    useEffect(() => {
        const connectedStatus = localStorage.getItem("isConnected");
        setIsConnected(connectedStatus === "true");
    }, []);

    const handleConnect = async () => {
        if (!isConnected) {
            try {
                tonConnectUI.openModal();
                closeModal();
                setIsConnected(true);
                localStorage.setItem("isConnected", "true"); // Сохраняем статус подключения
            } catch (error) {
                console.error("Error connecting wallet:", error);
            }
        }
    };

    const handleDisconnect = async () => {
        try {
            await tonConnectUI.disconnect();
            closeModal();
            setIsConnected(false);
            localStorage.setItem("isConnected", "false");
        } catch (error) {
            console.error("Error disconnecting wallet:", error);
        }
    };

    return (
        <div>
            {isConnected ? (                
                <div onClick={handleDisconnect}><TonConnectButton/></div>
            ) : (
                <div onClick={handleConnect}><TonConnectButton/></div>
            )}
        </div>
    );
};

export default WalletActions;
